import React from "react";
import "./Spacer.styles.scss";

const Spacer = () => {
  return <hr />;
};

export default Spacer;
